<!--suppress AngularNgOptimizedImage -->
<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb
        [items]="[
          { label: 'PERSONAL', link: '/admin/user-list' },
          { label: 'PERFIL' }
        ]">
      </app-breadcrumb>
    </div>

    <div class="row clearfix">
      <!-- Columna izquierda: Perfil -->
      <div class="col-lg-4 col-md-12">
        <div class="card card-user-profile">
          <div class="profile-content">
            <!-- Foto con Fallback -->
            <ng-container *ngIf="userImage && userImage.trim() !== ''; else empleadoIcon">
              <img alt="Foto de Perfil" class="profile-img" [src]="userImage">
            </ng-container>
            <ng-template #empleadoIcon>
              <img alt="Empleado" class="profile-img" src="assets/images/empleado.png">
            </ng-template>

            <div class="profile-text">
              <div class="profile-name">
                {{ user.nombres }} {{ user.primerApellido }} {{ user.segundoApellido }}
              </div>

              <!-- Badges: Tipo de usuario (principal) y Rol (opcional) -->
              <div class="profile-badges">
                <span class="pill pill-primary" *ngIf="user?.tipoUsuario as tipo">
                  {{ tipo }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Columna derecha: Acordeones -->
      <div class="col-lg-8 col-md-12">
        <mat-accordion multi="true" class="details-accordion">

          <!-- Panel 1: Identidad y Contacto -->
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>badge</mat-icon>IDENTIDAD Y CONTACTO
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="panel-content">
              <div class="grid-2 gap-xl">
                <div class="stack">
                  <div class="datos-item">
                    <span class="datos-label">NOMBRE COMPLETO</span>
                    <span class="datos-valor">
                      {{ user.nombres }} {{ user.primerApellido }} {{ user.segundoApellido }}
                    </span>
                  </div>
                  <div class="datos-item">
                    <span class="datos-label">CORREO</span>
                    <span class="datos-valor no-uppercase">{{ user.email }}</span>
                  </div>
                </div>

                <div class="stack">
                  <div class="datos-item">
                    <span class="datos-label">USUARIO</span>
                    <span class="datos-valor no-uppercase">{{ user.usr }}</span>
                  </div>
                  <div class="datos-item">
                    <span class="datos-label">TELEFONO</span>
                    <span class="datos-valor">{{ user.movil | formatMobile }}</span>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>

          <!-- Panel 2: Domicilio y Ubicacion -->
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>home</mat-icon>DOMICILIO Y UBICACION
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="panel-content">
              <div class="stack">
                <!-- Direccion completa en una sola fila -->
                <div class="datos-item full-width">
                  <span class="datos-label">DOMICILIO</span>
                  <span class="datos-valor">{{ user.domicilio }}</span>
                </div>

                <!-- Fila 1: 3 columnas -->
                <div class="grid-3">
                  <div class="datos-item">
                    <span class="datos-label">CODIGO POSTAL</span>
                    <span class="datos-valor">{{ user.codigoPostal }}</span>
                  </div>
                  <div class="datos-item">
                    <span class="datos-label">ASENTAMIENTO</span>
                    <span class="datos-valor">{{ user.nombreAsentamiento }}</span>
                  </div>
                  <div class="datos-item">
                    <span class="datos-label">TIPO DE ASENTAMIENTO</span>
                    <span class="datos-valor">{{ user.tipoAsentamiento }}</span>
                  </div>
                </div>

                <!-- Fila 2: 3 columnas -->
                <div class="grid-3">
                  <div class="datos-item">
                    <span class="datos-label">MUNICIPIO</span>
                    <span class="datos-valor">{{ user.municipio }}</span>
                  </div>
                  <div class="datos-item">
                    <span class="datos-label">ESTADO</span>
                    <span class="datos-valor">{{ user.estado }}</span>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>

          <!-- Panel 3: Empresa -->
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>business</mat-icon>EMPRESA
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="panel-content">
              <div class="grid-2">
                <div class="datos-item">
                  <span class="datos-label">GRUPO EMPRESARIAL</span>
                  <span class="datos-valor">{{ user.empresa }}</span>
                </div>
                <div class="datos-item">
                  <span class="datos-label">SUCURSAL</span>
                  <span class="datos-valor">{{ user.nombreSucursal }}</span>
                </div>
              </div>
            </div>
          </mat-expansion-panel>

        </mat-accordion>
      </div>
    </div>
  </div>
</section>
